import { FC } from 'react'
import cx from 'classnames'
import styles from './styles.module.scss'

import { Link } from '../Link'
import { OpenAccountButton } from '../OpenAccount/OpenAccountButton'

import { DownloadButton } from '../DownloadButton'
import { CmsAsset } from '../Sections/PageHero'

export interface PanelTitlesProps {
  title?: string
  subtitle?: string
  ctaText?: string
  ctaUrl?: string
  showOpenAccountButton?: boolean
  downloadButtonText?: string
  downloadableAsset?: CmsAsset
  className?: string
}

export const PanelTitles: FC<PanelTitlesProps> = ({
  title,
  subtitle,
  ctaText,
  ctaUrl,
  showOpenAccountButton,
  className,
  downloadableAsset,
  downloadButtonText,
}) => {
  const hasContent = () =>
    title ||
    subtitle ||
    (ctaText && ctaUrl) ||
    showOpenAccountButton ||
    (downloadButtonText && downloadableAsset)

  return hasContent() ? (
    <div
      className={cx(styles.panelTitles, className, {
        [styles.containsCta]: (ctaText && ctaUrl) || showOpenAccountButton,
      })}
    >
      {title && <h3 className={styles.panelTitle}>{title}</h3>}
      {subtitle && <p className={styles.panelSubtitle}>{subtitle}</p>}
      {((ctaText && ctaUrl) || showOpenAccountButton) && (
        <div className={styles.ctaContainer}>
          {showOpenAccountButton && <OpenAccountButton />}
          <Link className={styles.url} url={ctaUrl}>
            {ctaText}
          </Link>
        </div>
      )}

      {downloadButtonText && downloadableAsset && (
        <DownloadButton
          downloadButtonText={downloadButtonText}
          downloadableAsset={downloadableAsset}
        />
      )}
    </div>
  ) : null
}
